import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense } from 'react';
import jQuery from 'jquery';
import { GetCartData, GetCommonSettings, GetProductData } from '@themes/common/data';
import { createRoot } from 'react-dom/client';
const CartItems = lazy(() => import(/* webpackChunkName: 'CartItems', webpackPrefetch: true */ './main'));
const PalletModal = lazy(() => import(/* webpackChunkName: 'PalletModal', webpackPrefetch: true */ './palletmodal'));
export default function Cart() {
    const element = document.getElementById('sb-cart-items');
    if (element) {
        globalThis.sb_processing = 0;
        const fetch = () => {
            const cart = GetCartData();
            const settings = GetCommonSettings();
            const products = {};
            for (const item of cart.items) {
                const data = GetProductData(item.id);
                if (data) {
                    products[item.key] = data;
                }
            }
            const rootDom = createRoot(element);
            rootDom.render(_jsx(Suspense, Object.assign({ fallback: _jsx("div", { dangerouslySetInnerHTML: { __html: jQuery(element).html() } }) }, { children: _jsx(CartItems, { settings: settings, cart: cart, products: products }) })));
        };
        fetch();
    }
    const modalElement = document.getElementById('sb-cart-modals');
    if (modalElement) {
        const modalRootDom = createRoot(modalElement);
        modalRootDom.render(_jsx(Suspense, Object.assign({ fallback: _jsx("div", {}) }, { children: _jsx(PalletModal, {}) })));
    }
}
